import { useState, useEffect } from 'react'
import { useDebouncedCallback } from '@workspace/frontend-kit'
import { City, UseCitySearchProps } from './_props'
import { searchCities } from '../utils/birthCities'

const useCitySearch = ({ searchText, birthDate }: UseCitySearchProps) => {
    const [cities, setCities] = useState<City[]>([])
    const [loading, setLoading] = useState(false)

    const fetchCities = async (term: string) => {
        if (!term.length) {
            setCities([])
            setLoading(false)
            return
        }

        setLoading(true)
        const isCodeInsee = /\d+/g.test(term)

        try {
            const result = await searchCities(term, birthDate, isCodeInsee)
            setCities(result || [])
        } catch {
            setCities([])
        } finally {
            setLoading(false)
        }
    }

    const debouncedFetchCities = useDebouncedCallback(fetchCities, 300)

    useEffect(() => {
        debouncedFetchCities(searchText ?? '')
    }, [searchText, debouncedFetchCities])

    return {
        cities,
        loading,
    }
}

export default useCitySearch
